import { environment } from 'src/environment';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseService, SettingsService, StorageService } from 'src/app/core/services';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { PaymentService } from 'src/app/core/services/payment.service';
import { K_QUERY_PARAM_TV, K_QUERY_PARAM_APPLE_TV,  SOCIAL_APP_TV_FLAG, SOCIAL_SMART_APP_TV_FLAG, R_VOUCHER_PLAN, R_ACCOUNT_SETTINGS, COUPON } from '../../constants';
import { SubscriptionService } from 'src/app/core/services/subscription.service';
import { PlanService } from 'src/app/core/services/plan.service';
import { ApplicationService } from 'src/app/core/services/application.service';
import { NgClass, NgFor, NgIf, NgStyle } from '@angular/common';

@Component({
  selector: 'app-signup-step',
  templateUrl: './signup-step.component.html',
  styleUrls: ['./signup-step.component.scss'],
  standalone: true,
  imports: [NgIf, NgFor, NgClass, NgStyle]
})
export class SignupStepComponent implements OnInit {

  @Input() backRoute: string;
  @Input() currentStep: number;
  @Input() headPadding = '20px';
  @Input() page = '';
  @Output() emitStep = new EventEmitter<Number>();
  totalStep = 3;
  @Input() type;
  @Input() gotToPreviousPopUp;
  userSelectedPlan;
  @Input() showChangePlan;
  plansLength: any;
  operatorPage;
  @Input() showBackArrow;
  @Input() hideSteps;
  @Input()plans;
  showDiscountAmount = false;

  skinName = environment.skinName;
  constructor(public baseService: BaseService, public configService: ConfigurationService,
    private route: ActivatedRoute, private storageService: StorageService,
    private router: Router, private paymentService: PaymentService,
    private settingsService: SettingsService, private subscriptionService: SubscriptionService,
    public planService: PlanService, private appService: ApplicationService) { }

  ngOnInit(): void {
    this.operatorPage = this.router.url.match('operators');
    const paymentMethodLength = this.appService.userPaymentMethods?.length;
    this.showBackArrow = (this.showBackArrow && paymentMethodLength > 1) ? true : false
    // getting plan id and plan plans length from paywall through url queryparams
    const planId = this.route.snapshot?.queryParams?.plan_id;
    this.plansLength = this.planService.plansLength; // plans length is used to show change link which navigates to plans page
    if (planId) this.getSelectedPlanDetails(planId);
    else if (this.plansLength) {this.getAllPlans();}
    this.userSelectedPlan = this.storageService.getSessionStore('selectedPlanData');
    const discount_code = this.storageService.getLocalStore('discount_code');
    const discount_type = this.storageService.getLocalStore('discount_type');
    this.showDiscountAmount = (discount_type === COUPON && discount_code && this.userSelectedPlan?.coupon_mapped && this.userSelectedPlan?.coupon_type === 'discount') ? true : false;
    if(paymentMethodLength > 1 || this.type === 'redeemCoupon') this.totalStep = 4
    else this.totalStep = 3;
    if (this.page === 'account' || this.page === 'live') this.totalStep = this.totalStep - 1;
  }

  mobileNavigate() {
    const queryParams = this.route.snapshot.queryParams;
    const contentDetailPage = this.router.url.match('/v/')|| this.router.url.match('/video/')  || this.router.url.match('/series/') || this.router.url.match('/vs/'); 
    if (this.page === 'account' || this.page === 'live' || this.router.routerState.snapshot.url === this.backRoute || this.router.routerState.snapshot.url.match('/live') || this.router.routerState.snapshot.url.match('/home') || contentDetailPage?.length || this.gotToPreviousPopUp) {
      this.emitStep.emit(this.currentStep - 1);
      return;
    }
    if (this.router.routerState.snapshot.url === R_VOUCHER_PLAN) {
      this.storageService.removeLocalStore('discount_type');
      this.storageService.removeLocalStore('discount_code');
    };
    if (this.currentStep === 2) {
      const socailAppTvFlag = this.storageService.getLocalStore(SOCIAL_APP_TV_FLAG);
      const socailSmartTvFlag = this.storageService.getLocalStore(SOCIAL_SMART_APP_TV_FLAG);
      if (queryParams.app === K_QUERY_PARAM_TV || socailAppTvFlag === '1') {
        this.storageService.removeLocalStore(SOCIAL_APP_TV_FLAG);
        if (this.settingsService.activateYourTvFromTVCode) this.router.navigateByUrl('account/activate-tv');
        if (this.settingsService.activateYourTvFromWebCode) this.router.navigateByUrl('account/authenticate');
      } else if (queryParams.app === K_QUERY_PARAM_APPLE_TV || socailSmartTvFlag === '1') {
        this.storageService.removeLocalStore(SOCIAL_SMART_APP_TV_FLAG);
        if (this.settingsService.activateYourTvFromTVCode) this.router.navigateByUrl('account/activate-tv');
        if (this.settingsService.activateYourTvFromWebCode) this.router.navigateByUrl('account/authenticate');
      } else {
        this.router.navigateByUrl(this.backRoute)
      }
    } else {
      if (this.router.routerState.snapshot.url === R_VOUCHER_PLAN) {
        this.storageService.removeLocalStore('discount_type');
        this.storageService.removeLocalStore('discount_code');
        this.storageService.removeLocalStore('operator_voucher');
      };
      if (queryParams.app === K_QUERY_PARAM_APPLE_TV) {
        this.baseService.routeFn(this.backRoute, this.baseService.keyQueryParamAppleTV)
      } else {
        this.baseService.routeFn(this.backRoute, this.baseService.keyQueryParamTV);
      }
    }
  }

  getAllPlans() {
    const u_id = this.storageService.getLocalStore('u_id');
    let guest;
    this.baseService.guest.subscribe(data => guest = data);
    if (u_id || (guest && (this.router.url.includes('auth/plan') || this.router.url.includes('auth/signup') || this.router.url.includes('voucher/plan')))) {
      if(this.plans){
        if(this.plans.plans?.length == 1){
          this.storageService.setSessionStore('selectedPlanData', this.plans?.plans[0]);
          this.storeFreeTrialInfo(this.plans?.plans[0]);
        }
      }else {
          this.subscriptionService.userPlan().subscribe((data) => {
            if (data) {
              if (data.plans?.length == 1) {
                this.storageService.setSessionStore('selectedPlanData', data?.plans[0]);
                this.storeFreeTrialInfo(data?.plans[0]);
              }
            }
          });
      }
    }
  }

  getSelectedPlanDetails(planId) {
    // getting the plans detail to display in signup page
    this.subscriptionService.invoiceUserPlan(planId).subscribe(res => {
      this.userSelectedPlan = res?.plan;
      this.storageService.setSessionStore('selectedPlanData', this.userSelectedPlan);
    });
  }

  storeFreeTrialInfo(data) {
    // Storing free trial days free trial text in localstorage as those values used on other components
    this.storageService.setLocalStore('freeTrialDays', data?.free_trial_days);
    if (data?.free_trial_days > 0) this.storageService.setLocalStore('freeTrialText', data?.free_trial_text);
    else this.storageService.removeLocalStore('freeTrialDays');
  }

  changeBtnNavigate() {
    const contentDetailPage = this.router.url.match('/v/') ||this.router.url.match('/video/')  || this.router.url.match('/series/') || this.router.url.match('/vs/');
    if (this.page === 'account' || this.page === 'live' || this.router.routerState.snapshot.url === this.backRoute || this.router.routerState.snapshot.url.match('/live') || this.router.routerState.snapshot.url.match('/home') || contentDetailPage?.length || this.gotToPreviousPopUp) {
      const PaymentMethodsLength = this.appService.userPaymentMethods?.length;
      if (PaymentMethodsLength > 1 && this.currentStep == 3) this.emitStep.emit(this.currentStep - 2);
      else this.emitStep.emit(this.currentStep - 1)
    } else {
      const discount_code = this.storageService.getLocalStore('discount_code');
      const discount_type = this.storageService.getLocalStore('discount_type');
      if (discount_type === COUPON && discount_code) this.router.navigateByUrl('/voucher/plan');
      else this.router.navigateByUrl('/auth/plan');
    }
  }

}
